import axiosApiInstance from 'src/api/axiosConfig';
import { ScheduleCalendarEvent } from '../../List/ScheduleCalendar/ScheduleCalendar.types';

export const fetchLessonData = async (id: ScheduleCalendarEvent['id']): Promise<any | undefined> => {
    const { data } = await axiosApiInstance.get(`lessons/${id}`);

    return data;
};
